<template>
  <ExpenseForm mode="add" />
</template>

<script>
import ExpenseForm from "@/components/expense/ExpenseForm.vue";

export default {
  name: "createexpense",
  components: { ExpenseForm },
};
</script>
